export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6109.e42a4c9a.jpg";